import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../../components/button'

import styles from './redeem-voucher-warning.css'

function RedeemVoucherWarning({
  warningContent,
  redeemThisVoucher,
  onCancelCta
}) {
  const { message, cta, cancelCta } = warningContent

  return (
    <div className={styles.wrapper}>
      <p className={styles.message}>
        {message}
      </p>
      <div className={styles.buttons}>
        <Button
          wrapperClassName={styles.buttonWrapper}
          className={styles.btn}
          text={cta}
          onClick={redeemThisVoucher}
        />
        <Button
          wrapperClassName={styles.buttonWrapper}
          className={styles.btn}
          text={cancelCta}
          outlined
          onClick={() => onCancelCta()}
        />
      </div>
    </div>
  )
}

RedeemVoucherWarning.propTypes = {
  warningContent: PropTypes.shape({
    message: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    cancelCta: PropTypes.string.isRequired
  }).isRequired,
  redeemThisVoucher: PropTypes.func.isRequired,
  onCancelCta: PropTypes.func.isRequired
}

export default RedeemVoucherWarning
